var _rect, _rect2, _rect3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.9938,
    height: 80.1207,
    rx: 39.9969,
    transform: "matrix(1 -1.41549e-05 -1.41295e-05 1 0.133545 0.286743)",
    fill: "url(#paint0_linear_32_837)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.741848,
    y: 0.741848,
    width: 63.7998,
    height: 63.7998,
    rx: 31.8999,
    transform: "matrix(1 -1.41549e-05 -1.41295e-05 1 7.55226 7.70521)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.741848,
    y: 0.741848,
    width: 63.7998,
    height: 63.7998,
    rx: 31.8999,
    transform: "matrix(1 -1.41549e-05 -1.41295e-05 1 7.55226 7.70521)",
    stroke: "url(#paint1_linear_32_837)",
    strokeWidth: 1.48372
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.929 24.2728L33.4594 24.273C27.6086 24.2731 24.1206 27.7611 24.1205 33.6119L24.1203 47.0655C24.1202 52.9324 27.6081 56.4203 33.4589 56.4202L46.9125 56.42C52.7633 56.4199 56.2513 52.9319 56.2514 47.0811L56.2516 33.6115C56.2677 27.7607 52.7798 24.2728 46.929 24.2728ZM39.4385 42.8058L33.459 48.7853L36.9791 48.7852C37.6381 48.7852 38.1846 49.3317 38.1846 49.9907C38.1846 50.6497 37.6381 51.1962 36.9791 51.1962L30.5497 51.1963C30.3889 51.1963 30.2282 51.1642 30.0835 51.0999C29.7942 50.9713 29.5531 50.7463 29.4245 50.4409C29.3763 50.2962 29.3442 50.1516 29.3442 49.9908L29.3443 43.5614C29.3443 42.9024 29.8908 42.3559 30.5498 42.3559C31.2088 42.3559 31.7553 42.9023 31.7553 43.5614L31.7552 47.0815L37.7347 41.102C38.2008 40.6359 38.9724 40.6359 39.4385 41.102C39.9046 41.5681 39.9046 42.3397 39.4385 42.8058ZM51.0437 37.1317C51.0437 37.7907 50.4972 38.3372 49.8382 38.3372C49.1791 38.3372 48.6326 37.7907 48.6327 37.1317L48.6327 33.6116L42.6532 39.591C42.4121 39.8321 42.1067 39.9447 41.8013 39.9447C41.4959 39.9447 41.1905 39.8322 40.9494 39.5911C40.4833 39.1249 40.4833 38.3534 40.9495 37.8873L46.9289 31.9078L43.4088 31.9078C42.7498 31.9079 42.2033 31.3614 42.2033 30.7023C42.2033 30.0433 42.7498 29.4968 43.4088 29.4968L49.8383 29.4967C49.999 29.4967 50.1437 29.5289 50.3044 29.5932C50.5937 29.7217 50.8348 29.9468 50.9634 30.2522C51.0116 30.3968 51.0438 30.5415 51.0438 30.7022L51.0437 37.1317Z",
    fill: "url(#paint2_linear_32_837)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_837",
    x1: 4.68445e-7,
    y1: 39.6928,
    x2: 79.9938,
    y2: 39.6928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_837",
    x1: 65.2835,
    y1: 65.2835,
    x2: -8.9843,
    y2: 52.5977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38C682"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32_837",
    x1: 56.2513,
    y1: 56.4199,
    x2: 19.6975,
    y2: 50.1787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38C682"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.637bc9caec27a0c17051172e9e8e2d63.svg";
export { ForwardRef as ReactComponent };